import XHR from '@/api'
export default {
  data: () => ({
    // 设备类型
    deviceType: ''
  }),
  created () {
    this.deviceType = this.getType()
  },
  computed: {},
  methods: {
    // 判断是什么端
    getType () {
      const uaCase = navigator.userAgent
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        return 'weixin'
      } else if (uaCase.toLowerCase().indexOf('360che') >= 0) {
        return 'app'
      } else if (
        /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(
          navigator.userAgent
        )
      ) {
        return 'm'
      } else {
        return 'pc'
      }
    },
    // ios微信失去焦点问题
    onBlur () {
      const timer = setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        timer && clearTimeout(timer)
      }, 100)
    },
    // 微信注册
    wxConfig () {
      const wx = window.wx
      const href = window.location.href.split('#')[0]
      const json = {
        url: href
      }
      XHR.getWechatJsSdk(json).then(res => {
        // 注册微信信息
        const data = res.data
        try {
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
              // 分享操作接口
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
          this.wxsharePage()
        } catch (e) {}
      })
    },
    // 分享页面
    wxsharePage () {
      if (this.deviceType === 'weixin') {
        const wx = window.wx
        wx.ready(() => {
          wx.onMenuShareTimeline({
            title: window.shareLink.title, // 分享标题
            desc: window.shareLink.desc, // 分享描述
            link: window.shareLink.url, // 分享链接
            imgUrl: window.shareLink.imgUrl, // 分享图标
            success: () => {}
          })
          wx.onMenuShareAppMessage({
            title: window.shareLink.title, // 分享标题
            desc: window.shareLink.desc, // 分享描述
            link: window.shareLink.url, // 分享链接
            imgUrl: window.shareLink.imgUrl, // 分享图标
            success: () => {}
          })
        })
      }
    },
    appShareBtn () {
      if (this.deviceType === 'app') {
        window.callNativeMethod('onShowShareButton', {
          isShow: true,
          title: window.shareLink.title, // 分享标题
          desc: window.shareLink.desc, // 分享描述
          link: window.shareLink.url, // 分享链接
          imgUrl: window.shareLink.imgUrl // 分享图标
        })
      }
    },
    sendAnalytics (c, a, l) {
      setTimeout(() => {
        try {
          // eslint-disable-next-line
          ga('send', 'event', c, a, l)
        } catch (e) {}
      }, 0)
    },
    // 视频播放
    /* eslint-disable */
    playVideo (data, index, videoBox, titBox) {
      if (data && data.length) {
        document.querySelector(videoBox).innerHTML = ''
        let script = document.createElement('script')
        script.src = data[index].link // 填自己的js路径
        document.querySelector(videoBox).appendChild(script)
        document.querySelector(titBox).innerHTML = data[index].title
      }
    },
    /**
     * 滚动节流
     * @param:{Function}func-
     * @param:{number}wait-等待时间
     * @param:{number}mustRun-运行间隔
     */
    throttle (func, wait, mustRun) {
      let timeout
      let startTime = new Date()
      return function () {
        const curTime = new Date()
        clearTimeout(timeout)
        // 如果达到了规定的触发时间间隔，触发 handler
        if (curTime - startTime >= mustRun) {
          func()
          startTime = curTime
          // 没达到触发间隔，重新设定定时器
        } else {
          timeout = setTimeout(func, wait)
        }
      }
    },
    // 资讯、视频app跳转适配
    toNews (title, link, type, id) {
      type = Number(type)
      /* eslint-disable */
      if (this.deviceType === 'app') {
        if (type === 3) {
          // 资讯
          // 老版app
          if (window.CHENORMAL) {
            window.callNativeMethod('onOpenNewsWeb', {
              articleId: id
            })
          }
          // 急速版app
          if (window.CHESPEED) {
            const url = `https://news-app.360che.com/article.html?articleId=${id}`
            window.callNativeMethod('onOpenInfoImageTextDetail', {
              newsId: id,
              newsLink: url
            })
          }
        } else if (type === 4) {
          // 论坛
          if (window.CHENORMAL) {
            window.callNativeMethod('onOpenBbsWeb', { bbsId: id })
          }
          if (window.CHESPEED) {
            // 和子斌商量论坛统一跳到长文
            window.callNativeMethod('onOpenCommunityRichPostDetail', {
              tid: id
            })
          }
        } else if (type === 1) {
          // 视频
          // 老版app
          if (window.CHENORMAL) {
            window.callNativeMethod('onOpenNewsVideoWeb', {
              videoId: id
            })
          }
          // 急速版app
          if (window.CHESPEED) {
            const url = `https://news-app.360che.com/video.html?videoId=${id}`
            // 视频
            window.callNativeMethod('onOpenInfoVideoDetail', {
              videoId: id,
              videoLink: url
            })
          }
        } else {
          window.callNativeMethod('onOpenCommonWeb', {
            url: link,
            title: title
          })
        }
      } else if (this.deviceType === 'pc') {
        window.open(link)
      } else {
        window.location.href = link
      }
      /* eslint-enable */
    },
    openUrl (title, link) {
      if (this.deviceType === 'app') {
        window.callNativeMethod('onOpenCommonWeb', {
          url: link,
          title: title
        })
      } else {
        window.open(link)
      }
    },
    tips (text, type) {
      this.$showToast.show({
        type: type,
        text: text,
        time: 2000
      })
    },
    // 大数据埋点
    setAnalytics (a, l) {
      /* eslint-disable */
      l = l || ''
      try {
        Truckhome_eventFun('ck_topic', a, l)
      } catch (e) { }
      /* eslint-enable */
    }
  }
}
